export interface StatisticsChipData {
  id: string;
  name: string;
  value: number;
}

export interface StatisticsChartItem {
  id: string;
  value: number;
  label: string;
  color: string;
}

export interface StatisticsChartData {
  id: string;
  name: string;
  items: StatisticsChartItem[];
}

export interface SmsStats {
  allSmsCount: string;
  smsNotificationCount: string;
  twoFactorAuthSmsCount: string;
}

export interface sesionStats {
  examTaskGroupSolutionDownloadedCount: {
    downloaded: string;
    notDownloaded: string;
  };
  examTaskGroupSolutionScoreStatesCount: {
    new: string;
    open: string;
    assessed: string;
    closed: string;
  };
  taskSolutionSheetsStatusesCount: {
    downloadError: string;
    scanError: string;
    examSheetLack: string;
    examineeLack: string;
    duplicatedSheet: string;
    incompleteSheet: string;
    completeSheet: string;
    new: string;
  };
  examineeSheetStatusesCount: {
    complete: string;
    incomplete: string;
    empty: string;
  };
  specialCaseStats: {
    inProgress: string;
    resolved: string;
  };
}

export enum SmsStatName {
  allSmsCount = 'wysłanych SMS ogółem',
  twoFactorAuthSmsCount = 'wysłanych SMS autoryzacyjnych',
  smsNotificationCount = 'wysłanych SMS w module komunikacji',
}

export enum ExamSheetStatName {
  specialCaseStats = 'suma wszystkich zgłoszonych szczególnych przypadków',
  examineeSheetStatusesCount = 'liczba wszystkich zdających posiadających wskazany arkusz',
  taskSolutionSheetsStatusesCount = 'liczba wszystkich kart rozwiązań zadań dla wskazanego arkusza',
}
